"use client";

import ArrowLeftIcon from "@/app/_components/Icons/ArrowLeftIcon";
import { Button, Icon } from "@mui/material";
import { useEffect, useState } from "react";

export default function GoBackButton() {
  const [canGoBack, setCanGoBack] = useState(true);

  useEffect(() => {
    if (!(typeof window !== "undefined" && window.history.length > 1)) {
      setCanGoBack(false);
    }
  }, []); // Run only once after component mounts

  if (canGoBack) {
    return (
      <Button
        onClick={() => {
          if (typeof window !== "undefined" && window.history.length > 1 && window.history.length > 1) {
            window.history.back();
          }
        }}
        sx={{
          ml: "auto",
          minWidth: "auto",
          flexShrink: 0,
          p: 0.7,
          borderRadius: 32,
          display: { md: "none", xs: "flex" },
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "grey.50",
        }}
        disableElevation
        variant="text"
      >
        <Icon fontSize="small" sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
          <ArrowLeftIcon />
        </Icon>
      </Button>
    );
  }

  return <></>;
}
